var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copy",
    opacity: 0.5,
    clipPath: "url(#clip0_5698_14514)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Money"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    d: "M3 5.33398L3 12.0007C3 12.737 3.59695 13.334 4.33333 13.334L8.33333 13.334C9.06971 13.334 9.66667 12.737 9.66667 12.0007L9.66667 5.33398C9.66667 4.5976 9.06971 4.00065 8.33333 4.00065L4.33333 4.00065C3.59695 4.00065 3 4.5976 3 5.33398Z",
    stroke: "#0C0310",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2",
    d: "M6.33301 3.33398C6.33301 2.59761 6.92996 2.00065 7.66634 2.00065L11.6663 2.00065C12.4027 2.00065 12.9997 2.5976 12.9997 3.33398L12.9997 10.0007C12.9997 10.737 12.4027 11.334 11.6663 11.334L10 11.334",
    stroke: "#0C0310",
    strokeLinecap: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5698_14514"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "matrix(-1 8.74228e-08 8.74228e-08 1 16 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy_icon.53e9af1f91860c0a9cd7c18e99ba0668.svg";
export { ForwardRef as ReactComponent };